// removed by extract-text-webpack-plugin
module.exports = {"component":"_1kszimQZvmbl_pQtdCSb8H","title":"wEjv6gIZQYFSo0ZsCUL5L","backButton":"_1aWj4nqQ_tryjq9mv5KudF","actions":"_2jfqBvaT9oOoc2sTe-cB7-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderBar/HeaderPanelActions.css
// module id = 990
// module chunks = 0